import { useTranslations } from 'next-intl';
import HeadlessModal from './shared/HeadlessModal';
import { STOREFRONT } from '@/lib/utils/translation';

type FavoriteLoginModalProps = {
  readonly isOpen: boolean;
  readonly setIsOpen: (open: boolean) => void;
  readonly redirectToLogin: () => void;
};

export default function FavoriteLoginModal({
  isOpen,
  setIsOpen,
  redirectToLogin,
}: FavoriteLoginModalProps) {
  const t = useTranslations();
  if (!isOpen) return null;

  return (
    <HeadlessModal
      isOpen={isOpen}
      closeModal={() => setIsOpen(false)}
      title={null}
      dialogBodyClass="overflow-y-auto"
    >
      <div className="favorite-login-modal-body mt-7 flex flex-col items-center space-y-5">
        <h2 className="text-center text-h3 font-bold">
          {t(
            `${STOREFRONT.FAVORITES}.you_must_be_logged_in_to_add_it_to_your_favorites`
          )}
        </h2>
        <button
          onClick={redirectToLogin}
          type="button"
          data-testid="favorite-login-modal-continue-button"
          aria-label={t(`${STOREFRONT.FAVORITES}.continue`)}
          className="rounded-full bg-primary px-12 py-4 text-h5 font-medium text-white transition-colors hover:bg-opacity-90"
        >
          {t('common.continue')}
        </button>
      </div>
    </HeadlessModal>
  );
}
